import {fetchWithToken} from '@hublot-io/core-api/client'
import downloadjs from 'downloadjs'
import groupBy from 'lodash.groupby'
import moment from 'moment'

import KeyboardService from '@/services/KeyboardService'
import {contexts} from '@/store/context'
import CalculUtils from '@/utils/calculUtils'
import CommonUtils from '@/utils/commonUtils'
import dateUtils from '@/utils/dateUtils'
import SentenceUtils from '@/utils/sentenceUtils'

import config from '../utils/apiUtils'

import {TracabiliteService} from './TracabiliteService'

export const HygieneService = {
  formatHour(value) {
    return value !== '' ? moment(value, 'HH:mm').format('HH[h]mm') : '--'
  },
  formatDate(value) {
    return value !== '' ? moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY') : '-'
  },
  getImagePath(currentContext, record) {
    if (!record) return ''

    if (record.uuid) {
      return TracabiliteService.getHygieneImg(currentContext, record.uuid)
    }
    if (record.file !== null && record.file !== '' && record.synced) {
      const regex = new RegExp('[^/]+(?=/$|$)')
      const uuid = record.file.match(regex)[0].split('.')[0]
      if (uuid !== null) {
        return TracabiliteService.getHygieneImg(currentContext, uuid)
      }
      return ''
    }
    return ''
  },
  downloadTemplate(data, template) {
    return fetchWithToken(`${config().pdfService}`, {
      method: 'POST',
      body: JSON.stringify({
        data,
        url: `${document.location.origin}/hygiene-export/${template}`
      })
    })
      .then(response => response.blob())
      .then(file => {
        downloadjs(file, `${data.title}.pdf`)
      })
  },

  signNettoyage(idEmployee, date) {
    return fetchWithToken(`${config().hygieneService}/nettoyage/sign`, {
      method: 'POST',
      body: JSON.stringify({
        idEmployee,
        date
      })
    })
  },
  getNettoyageSign(date) {
    return fetchWithToken(`${config().hygieneService}/nettoyage/sign?date=${date}`, {method: 'GET'}).then(response =>
      response.json()
    )
  },

  signTemperature(idEmployee, date) {
    return fetchWithToken(`${config().hygieneService}/temperatures/sign`, {
      method: 'POST',
      body: JSON.stringify({
        idEmployee,
        date
      })
    })
  },
  getTemperatureSign(date) {
    return fetchWithToken(`${config().hygieneService}/temperatures/sign?date=${date}`, {method: 'GET'}).then(response =>
      response.json()
    )
  },

  downloadNettoyage(data) {
    return fetchWithToken(`${config().pdfService}?landscape=true`, {
      method: 'POST',
      body: JSON.stringify({
        data,
        url: `${document.location.origin}/nettoyage-mois.html`
      })
    })
      .then(response => response.blob())
      .then(file => {
        downloadjs(file, `${data.title}.pdf`)
      })
  },

  downloadTemperature(data) {
    return fetchWithToken(`${config().pdfService}?landscape=true`, {
      method: 'POST',
      body: JSON.stringify({
        data,
        url: `${document.location.origin}/temperature-mois.html`
      })
    })
      .then(response => response.blob())
      .then(file => {
        downloadjs(file, `${data.title}.pdf`)
      })
  },

  getAuditsBy3Months: month =>
    fetchWithToken(`${config().hygieneService}/audit?month=${month}`, {method: 'GET'}).then(response =>
      response.json()
    ),
  getFraicheursBy3Months: month =>
    fetchWithToken(`${config().hygieneService}/fraicheur?month=${month}`, {method: 'GET'}).then(response =>
      response.json()
    ),
  getViviersBy3Months: month =>
    fetchWithToken(`${config().hygieneService}/viviers?month=${month}`, {method: 'GET'}).then(response =>
      response.json()
    ),
  getReceptionsBy3Months: (currentContext, month) =>
    fetchWithToken(`${config(currentContext).hygieneService}/receptions?month=${month}`, {method: 'GET'}).then(
      response => response.json()
    ),

  getMaturationsBy3Months: (currentContext, month) =>
    fetchWithToken(`${config(currentContext).hygieneService}/maturations?month=${month}`, {method: 'GET'}).then(
      response => response.json()
    ),
  getBarquettesBy3Months: (currentContext, month) =>
    fetchWithToken(`${config(currentContext).hygieneService}/barquettes?month=${month}`, {method: 'GET'}).then(
      response => response.json()
    ),

  getCuissonsBy3Months: month =>
    fetchWithToken(`${config().hygieneService}/cuissons?month=${month}`, {method: 'GET'}).then(response =>
      response.json()
    ),
  getTailleReglementaireBy3Months: month =>
    fetchWithToken(`${config().hygieneService}/tailleReglementaire?month=${month}`, {method: 'GET'}).then(response =>
      response.json()
    ),
  getPreparationsBy3Months: (currentContext, month) =>
    fetchWithToken(`${config(currentContext).hygieneService}/preparations?month=${month}`, {method: 'GET'}).then(
      response => response.json()
    ),
  getParasitismesBy3Months: month =>
    fetchWithToken(`${config().hygieneService}/parasitismes?month=${month}`, {method: 'GET'}).then(response =>
      response.json()
    ),
  getExpeditionsBy3Months: month =>
    fetchWithToken(`${config().hygieneService}/expeditions?month=${month}`, {method: 'GET'}).then(response =>
      response.json()
    ),
  getGlacagesBy3Months: month =>
    fetchWithToken(`${config().hygieneService}/glacages?month=${month}`, {method: 'GET'}).then(response =>
      response.json()
    ),
  getCongelationsBy3Months: month =>
    fetchWithToken(`${config().hygieneService}/congelations?month=${month}`, {method: 'GET'}).then(response =>
      response.json()
    ),
  getCalibragesBy3Months: (currentContext, month) =>
    fetchWithToken(`${config(currentContext).hygieneService}/calibrages?month=${month}`, {method: 'GET'}).then(
      response => response.json()
    ),
  getFumaisonsBy3Months: month =>
    fetchWithToken(`${config().hygieneService}/fumaisons?month=${month}`, {method: 'GET'}).then(response =>
      response.json()
    ),
  getTemperaturesBy3Months: (currentContext, month) =>
    fetchWithToken(`${config(currentContext).hygieneService}/temperatures?month=${month}`, {method: 'GET'}).then(
      response => response.json()
    ),
  getNettoyagesBy3Months: (currentContext, month) =>
    fetchWithToken(`${config(currentContext).hygieneService}/nettoyage?month=${month}`, {method: 'GET'}).then(
      response => response.json()
    ),

  downloadPreparation(data) {
    return fetchWithToken(`${config().pdfService}`, {
      method: 'POST',
      body: JSON.stringify({
        data,
        url: `${document.location.origin}/preparation.html`
      })
    })
      .then(response => response.blob())
      .then(file => {
        downloadjs(file, `${data.title}.pdf`)
      })
  },

  getAuditsByDate: date =>
    fetchWithToken(`${config().hygieneService}/audit?date=${date}`, {method: 'GET'}).then(response => response.json()),
  getAuditsByRange: (currentContext, dateStart, dateEnd) =>
    fetchWithToken(`${config(currentContext).hygieneService}/audit?dateStart=${dateStart}&dateEnd=${dateEnd}`, {
      method: 'GET'
    }).then(response => response.json()),
  formatAuditsToExport: (context, records) => {
    const recordsGrouped = groupBy(records, 'date')
    return Object.keys(recordsGrouped).map(record => ({
      record: {
        audits: recordsGrouped[record],
        formatedDate: moment(recordsGrouped[record][0].date, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm'),
        nomEmploye: recordsGrouped[record][0].nomEmploye,
        prenomEmploye: recordsGrouped[record][0].prenomEmploye
      },
      date: moment(recordsGrouped[record][0].date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
    }))
  },
  getViviersByDate: date =>
    fetchWithToken(`${config().hygieneService}/viviers?date=${date}`, {method: 'GET'}).then(response =>
      response.json()
    ),
  getViviersByRange: (dateStart, dateEnd, currentContext) =>
    fetchWithToken(`${config(currentContext).hygieneService}/viviers?dateStart=${dateStart}&dateEnd=${dateEnd}`, {
      method: 'GET'
    }).then(response => response.json()),
  getFraicheurByRange: (currentContext, dateStart, dateEnd) =>
    fetchWithToken(`${config(currentContext).hygieneService}/fraicheur?dateStart=${dateStart}&dateEnd=${dateEnd}`, {
      method: 'GET'
    }).then(response => response.json()),
  formatViviersToExport: (context, records) =>
    records.map(record => ({
      date: moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
      record: {
        ...record,
        formatedDate: `${moment(record.date).format('DD/MM/YYYY HH:mm:ss')}`,
        mortalite: CommonUtils.toBoolean(record.mortalite),
        charbon: CommonUtils.toBoolean(record.charbon),
        remplissageCuve: CommonUtils.toBoolean(record.remplissageCuve),
        remplissageCascade: CommonUtils.toBoolean(record.remplissageCascade)
      }
    })),
  formatFraicheurToExport: (context, records) => {
    return records.map(record => ({
      date: moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
      record: {
        ...record,
        formatedDate: `${moment(record.date).format('DD/MM/YYYY HH:mm:ss')}`,
        formatedPhotos: record.files.map(file => {
          return `${window.location.origin}/img/hygiene/fraicheur/${file.path}`
        })
      }
    }))
  },
  getBarquettesByDate: (currentContext, date) =>
    fetchWithToken(`${config(currentContext).hygieneService}/barquettes?date=${date}`, {method: 'GET'}).then(response =>
      response.json()
    ),
  getBarquettesByRange: (currentContext, dateStart, dateEnd) =>
    fetchWithToken(`${config(currentContext).hygieneService}/barquettes?dateStart=${dateStart}&dateEnd=${dateEnd}`, {
      method: 'GET'
    }).then(response => response.json()),
  formatBarquettesToExport: (currentContext, records) =>
    records.map(record => ({
      date: moment(record.date, 'YYYY-MM-DD').format('YYYY-MM-DD'),
      record: {
        ...record,
        formatedDate: `${moment(record.date).format('DD/MM/YYYY HH:mm:ss')}`
      }
    })),
  getMaturationsByDate: (currentContext, date) =>
    fetchWithToken(`${config(currentContext).hygieneService}/maturations?date=${date}`, {method: 'GET'}).then(
      response => response.json()
    ),
  getMaturationsByRange: (currentContext, dateStart, dateEnd) =>
    fetchWithToken(`${config(currentContext).hygieneService}/maturations?dateStart=${dateStart}&dateEnd=${dateEnd}`, {
      method: 'GET'
    }).then(response => response.json()),
  formatMaturationsToExport: (context, records) =>
    records.map(record => ({
      date: moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
      record: {
        ...record,
        formatedDate: `${moment(record.date).format('DD/MM/YYYY HH:mm:ss')}`
      }
    })),
  getReceptionsByDate: (currentContext, date) =>
    fetchWithToken(`${config(currentContext).hygieneService}/receptions?date=${date}`, {method: 'GET'}).then(response =>
      response.json()
    ),
  getReceptionsByRange: (currentContext, dateStart, dateEnd) =>
    fetchWithToken(`${config(currentContext).hygieneService}/receptions?dateStart=${dateStart}&dateEnd=${dateEnd}`, {
      method: 'GET'
    }).then(response => response.json()),

  formatReceptionsBoucherieToExport(context, record) {
    return {
      date: moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
      record: {
        ...record,
        formatedDate: `${moment(record.date).format('DD/MM/YYYY HH:mm:ss')}`,
        qualite: CommonUtils.toBoolean(record.qualite),
        isBoucherieContext: context === contexts.BOUCHERIE_CONTEXT,
        photos: record.file
          ? [record.file, record.livraisonFile]
              .map(photo =>
                HygieneService.getImagePath(context, {
                  file: photo,
                  synced: true
                })
              )
              .filter(image => image !== '')
          : [],
        isConform: CommonUtils.toBoolean(record.isConform)
      }
    }
  },
  formatReceptionsPoissonnerieToExport(context, record, serial, userType) {
    return {
      date: moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
      record: {
        ...record,
        userType,
        serial,
        formatedDate: `${moment(record.date).format('DD/MM/YYYY HH:mm:ss')}`,
        isPoissonnerieContext: context === contexts.POISSONNERIE_CONTEXT,
        isPoissonnerieMagasin: userType !== 6 && context === contexts.POISSONNERIE_CONTEXT,
        isMareyeur: userType === 6,
        qualite: CommonUtils.toBoolean(record.qualite),
        isScachap: serial === '2575.9934.1140.2685',
        isBoucherieContext: context === contexts.BOUCHERIE_CONTEXT,
        photos: record.files
          ? record.files.map(photo => HygieneService.getImagePath(context, {...photo, synced: true}))
          : []
      }
    }
  },

  formatReceptionsToExport: (context, records, serial, userType) =>
    records.map(record => {
      if (context === contexts.BOUCHERIE_CONTEXT) {
        return HygieneService.formatReceptionsBoucherieToExport(context, record, serial, userType)
      } else {
        return HygieneService.formatReceptionsPoissonnerieToExport(context, record, serial, userType)
      }
    }),
  formatViviers: records =>
    (records || []).map(record => ({
      title: `Relevé vivier du ${moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY [à] HH[h]mm')} ${record.nomVivier === '' || record.nomVivier === null ? '' : `(${record.nomVivier})`}`,
      subtitle: `Salinité : ${record.salinite} | Temperature : ${record.temperature} °C`,
      color: 'green',
      logo: 'vivier.png',
      date: moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
      record,
      component: 'recordVivier'
    })),

  getCuissonsByDate: date =>
    fetchWithToken(`${config().hygieneService}/cuissons?date=${date}`, {method: 'GET'}).then(response =>
      response.json()
    ),
  getCuissonsByUuid: uuid =>
    fetchWithToken(`${config().hygieneService}/cuissons/${uuid}`, {method: 'GET'}).then(response => response.json()),
  getCuissonsByRange: (currentContext, dateStart, dateEnd) =>
    fetchWithToken(`${config(currentContext).hygieneService}/cuissons?dateStart=${dateStart}&dateEnd=${dateEnd}`, {
      method: 'GET'
    }).then(response => response.json()),
  formatCuissonsToExport: (context, records) =>
    records.map(record => ({
      date: moment(record.dateDebut, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
      record: {
        ...record,
        img: HygieneService.getImagePath(context, record),
        DLC: HygieneService.formatDate(record.DLC),
        heureDebutCuisson: HygieneService.formatHour(record.heureDebutCuisson),
        heureFinCuisson: HygieneService.formatHour(record.heureFinCuisson),
        heureFinRefroidissement: HygieneService.formatHour(record.heureFinRefroidissement),
        formatedDateDebut: `${moment(record.dateDebut, 'YYYY-MM-DD').format('DD/MM/YYYY')} ${moment(record.heureDebutCuisson, 'HH:mm').format('à HH[h]mm')}`,
        tempsCuisson: (() => {
          moment.locale('fr')
          const date = moment(record.dateDebut, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD')
          const startCuisson = moment(`${date} ${record.heureDebutCuisson}`, 'YYYY-MM-DD HH:mm')
          const endCuisson = moment(`${date} ${record.heureFinCuisson}`, 'YYYY-MM-DD HH:mm')
          return moment.duration(endCuisson.diff(startCuisson)).humanize()
        })(),
        tempsRefroidissement: (() => {
          moment.locale('fr')
          const date = moment(record.dateDebut, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD')
          const endCuisson = moment(`${date} ${record.heureFinCuisson}`, 'YYYY-MM-DD HH:mm')
          const endRefroidissement = moment(`${date} ${record.heureFinRefroidissement}`, 'YYYY-MM-DD HH:mm')
          return moment.duration(endCuisson.diff(endRefroidissement)).humanize()
        })(),
        formatedCommentaires: (() => {
          if (record.actions.length === 0) {
            return 'RAS'
          }
          return record.actions
        })()
      }
    })),
  formatCuissons: records =>
    (records || []).map(record => ({
      title: `Cuisson du ${`${moment(record.dateDebut, 'YYYY-MM-DD').format('DD/MM/YYYY')} ${moment(record.heureDebutCuisson, 'HH:mm').format('à HH[h]mm')}`}`,
      subtitle: `N° de lot : ${record.lot} - ${record.text}`,
      color: 'orange',
      logo: 'cuisson.png',
      date: moment(record.dateDebut, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
      record,
      component: 'recordCuisson'
    })),

  getTailleReglementaireByDate: date =>
    fetchWithToken(`${config().hygieneService}/tailleReglementaire?date=${date}`, {method: 'GET'}).then(response =>
      response.json()
    ),
  getTailleReglementaireByRange: (currentContext, dateStart, dateEnd) =>
    fetchWithToken(
      `${config(currentContext).hygieneService}/tailleReglementaire?dateStart=${dateStart}&dateEnd=${dateEnd}`,
      {method: 'GET'}
    ).then(response => response.json()),
  formatTailleReglementaireToExport: (context, records) =>
    records.map(record => ({
      date: moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
      record: {
        ...record,
        formatedDate: `${moment(record.date).format('DD/MM/YYYY HH:mm:ss')}`,
        formatedCommentaires: (() => {
          if (record.commentaire.length === 0) {
            return 'RAS'
          }
          return record.commentaire
        })(),
        formatedAnisakis: (() => {
          if (!record.anisakis || record.anisakis === 'false') {
            return 'Non'
          }
          return 'Oui'
        })()
      }
    })),

  formatTailleReglementaire: records =>
    (records || []).map(record => ({
      title: `Taille de ${moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('HH[h]mm')}`,
      // Must be retreive with Fishkeyboard
      // 'Espèce : ' + record.text +
      subtitle: ` Taille : ${record.tailleReleve} ${record.uniteMesure} - ${record.text}`,
      color: 'blue',
      date: moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
      logo: 'rule.png',
      record,
      component: 'recordTailleReglementaire'
    })),
  getTemperaturesByDate: (date, currentContext) =>
    fetchWithToken(`${config(currentContext).hygieneService}/temperatures?date=${date}`, {method: 'GET'}).then(
      response => response.json()
    ),

  getTemperaturesByRange: (currentContext, dateStart, dateEnd) =>
    fetchWithToken(`${config(currentContext).hygieneService}/temperatures?dateStart=${dateStart}&dateEnd=${dateEnd}`, {
      method: 'GET'
    }).then(response => response.json()),
  getNettoyagesByDate: (date, currentContext) =>
    fetchWithToken(`${config(currentContext).hygieneService}/nettoyage?date=${date}`, {method: 'GET'}).then(response =>
      response.json()
    ),
  getNettoyagesByRange: (currentContext, dateStart, dateEnd) =>
    fetchWithToken(`${config(currentContext).hygieneService}/nettoyage?dateStart=${dateStart}&dateEnd=${dateEnd}`, {
      method: 'GET'
    }).then(response => response.json()),
  getNettoyagesByDateForPrint: date =>
    fetchWithToken(`${config().hygieneService}/nettoyage/print?date=${date}`, {method: 'GET'}).then(response =>
      response.json()
    ),
  getNettoyagesByTimestamp: (currentContext, dateDebut, dateFin) =>
    fetchWithToken(
      `${config(currentContext).hygieneService}/nettoyage/print?dateDebut=${dateDebut}&dateFin=${dateFin}`,
      {method: 'GET'}
    ).then(response => response.json()),
  getTemperaturesRulesByDate: date =>
    fetchWithToken(`${config().hygieneService}/temperatures/rule?date=${date}`, {method: 'GET'})
      .then(response => response.json())
      .catch(err => console.error('err on rules (date)', err)),
  getTemperaturesRulesByTimestamp: (dateDebut, dateFin) =>
    fetchWithToken(`${config().hygieneService}/temperatures/rule?dateDebut=${dateDebut}&dateFin=${dateFin}`, {
      method: 'GET'
    })
      .then(response => response.json())
      .catch(err => console.error('err on rules (timestamp)', err)),
  getTemperaturesFurnituresByTimestamp: (currentContext, dateDebut, dateFin) =>
    fetchWithToken(
      `${config(currentContext).hygieneService}/temperatures/furniture?dateDebut=${dateDebut}&dateFin=${dateFin}`,
      {method: 'GET'}
    )
      .then(response => response.json())
      .catch(err => console.error('err on furnitures (timestamp)', err)),

  formatTemperatureBoucherieToExport(record) {
    return {
      date: moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
      record: {
        ...record,
        formatedDate: (() => {
          return moment(record.date, 'YYYY-MM-DD HH:mm').format('DD/MM/YYYY à HH[h]mm')
        })(),
        haveMeuble: true,
        meubles: record.records
      }
    }
  },
  formatTemperaturePoissonnerieToExport(record) {
    return {
      date: moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
      record: {
        ...record,
        formatedDate: (() => {
          return moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY à HH[h]mm')
        })(),
        formatedCommentaires: (() => {
          if (record.products && record.meubles && record.products.length > 0 && record.meubles.length === 0) {
            if (!record.products[0].actions || record.products[0].actions.length === 0) {
              return 'RAS'
            }
            return record.products[0].actions
          }
          if (record.products && record.meubles && record.meubles.length > 0 && record.products.length === 0) {
            if (!record.meubles[0].actions || record.meubles[0].actions.length === 0) {
              return 'RAS'
            }
            return record.meubles[0].actions
          }
          if (record.products && record.meubles && record.meubles.length > 0 && record.products.length > 0) {
            return `Produits : ${record.products[0].actions} / Meubles : ${record.meubles[0].actions}`
          }
          return ''
        })(),
        haveMeuble: record.meubles && record.meubles.length,
        haveProducts: record.products && record.products.length,
        haveCoeur: record.coeur && record.coeur.length
      }
    }
  },
  formatTemperaturesToExport: (context, records) =>
    records.map(record => {
      if (context === contexts.BOUCHERIE_CONTEXT) {
        return HygieneService.formatTemperatureBoucherieToExport(record)
      } else {
        return HygieneService.formatTemperaturePoissonnerieToExport(record)
      }
    }),
  formatNettoyagePoissonnerieToExport(records) {
    const recordsGrouped = groupBy(records, 'date')
    return Object.keys(recordsGrouped).map(record => ({
      record: {
        nettoyages: recordsGrouped[record],
        formatedDate: moment(recordsGrouped[record][0].date, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm'),
        nom: recordsGrouped[record][0].nom,
        prenom: recordsGrouped[record][0].prenom
      },
      date: moment(recordsGrouped[record][0].date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
    }))
  },
  formatNettoyageBoucherieToExport(records) {
    return records.map(record => ({
      date: moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
      record: {
        ...record,
        formatedDate: moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm'),
        nettoyages: record.records
      }
    }))
  },
  formatNettoyagesToExport: (context, records) => {
    if (context === contexts.BOUCHERIE_CONTEXT) {
      return HygieneService.formatNettoyageBoucherieToExport(records)
    } else {
      return HygieneService.formatNettoyagePoissonnerieToExport(records)
    }
  },

  formatTemperatures: records =>
    (records || []).map(record => {
      const meubles = (() => {
        if (record.nbMeubles > 0) {
          return `${record.nbMeubles + SentenceUtils.pluralize(record.nbMeubles, [' meuble'])}`
        }
        return ''
      })()

      const produits = (() => {
        if (record.products && record.products.length > 0) {
          return record.products.map(product => product.nom).join(' ,')
        }
        return ''
      })()

      const coeur = (() => {
        if (record.nbCoeur > 0) {
          return `${record.nbCoeur + SentenceUtils.pluralize(record.nbCoeur, [' prise'])} à coeur`
        }
        return ''
      })()

      return {
        title: `Température ${moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('HH[h]mm')}`,
        subtitle: [produits, meubles, coeur].filter(title => title).join(' + '),
        color: '#820263',
        date: moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
        logo: 'temperature.png',
        record,
        component: 'recordTemperature'
      }
    }),
  formatTemperaturesBoucherie: records =>
    (records || []).map(record => ({
      title: `Température ${moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('HH[h]mm')}`,
      subtitle: `${record.records ? record.records.length : ''} enregistrements`,
      color: '#820263',
      date: moment(record.date, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD'),
      logo: 'temperature.png',
      record,
      component: 'recordTemperatureBoucherie'
    })),
  formatCalibragesBoucherie: records => {
    return (records || []).map(record => {
      const typeCalibrage = (() => {
        if (record.emballages[0]) {
          return 'emballage'
        }
        if (record.sondes[0]) {
          return 'sonde'
        }
        if (record.tares[0]) {
          return 'tare'
        }
        if (record.etancheites[0]) {
          return 'étanchéité'
        }
        return ''
      })()
      return {
        title: `Calibrage ${typeCalibrage} de ${moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('HH[h]mm')}`,
        subtitle: `Effectué par ${record.prenomEmployee} ${record.nomEmployee}`,
        color: '#03de9e',
        date: moment(record.date, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD'),
        logo: 'calibrage.png',
        record,
        component: 'recordCalibragesBoucherie'
      }
    })
  },
  formatMaturationsBoucherie: records =>
    (records || []).map(record => ({
      title: `Maturation du ${moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('HH[h]mm')}`,
      subtitle: `Effectué par ${record.prenomEmployee} ${record.nomEmployee}`,
      color: '#008000',
      date: moment(record.date, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD'),
      logo: 'maturation.png',
      record,
      component: 'recordMaturationsBoucherie'
    })),

  formatBarquettesBoucherie: records =>
    (records || []).map(record => ({
      title: `Entrée barquettes ${moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('HH[h]mm')}`,
      subtitle: `${record.nomBarquette}`,
      color: '#FFA500',
      date: moment(record.date, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD'),
      logo: 'barquette.png',
      record,
      component: 'recordBarquetteBoucherie'
    })),

  formatPreparationsBoucherie: records => {
    return (records || []).map(record => {
      return {
        title: `Préparation ${moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('HH[h]mm')}`,
        subtitle: `${record.poidsFinal} ${record.nomConditionnement} ${record.nomRecette}`,
        color: 'red',
        date: moment(record.date, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD'),
        logo: 'preparation.png',
        record,
        component: 'recordPreparationBoucherie'
      }
    })
  },

  getPreparations: currentContext =>
    fetchWithToken(`${config(currentContext).hygieneService}/preparations`, {method: 'GET'}).then(response =>
      response.json()
    ),
  getPreparationsByDate: (currentContext, date) =>
    fetchWithToken(`${config(currentContext).hygieneService}/preparations?date=${date}`, {method: 'GET'}).then(
      response => response.json()
    ),
  getPreparationsByRange: (currentContext, dateStart, dateEnd) =>
    fetchWithToken(`${config(currentContext).hygieneService}/preparations?dateStart=${dateStart}&dateEnd=${dateEnd}`, {
      method: 'GET'
    }).then(response => response.json()),

  formatPreparationsToExportPoisson(record, context, records, _1, _2, keyboard, conditionnementsVente) {
    const noImage =
      'https://nextcloud.hublot.io/apps/files_sharing/publicpreview/odKMxoMH5RKqW7L?file=/&fileId=7432220&x=2560&y=1440&a=true&etag=80884f4db0e5c2d2a7b9088f25d7b596'

    const getProductName = () => {
      return KeyboardService.retreiveSentenceWithQte(
        {...record, quantite: record.poidsFinal},
        conditionnementsVente,
        keyboard,
        'idConditionnementVente',
        [],
        'codesCommande',
        false,
        record.idCodeMagasin
      )
    }

    const getRecetteName = () => {
      return KeyboardService.retreiveSentence({idCode: record.idCode}, keyboard, record.idCodeMagasin)
    }

    const formatedOtherPreparation = () => {
      return record.products.filter(currentRecord => currentRecord.idOtherEnregistrementPreparation)
    }
    const formatedCuissons = () => {
      return record.products.filter(currentRecord => currentRecord.idEnregistrementCuisson)
    }
    const formatedProducts = () => {
      return record.products.filter(
        currentRecord => !currentRecord.idEnregistrementCuisson && !currentRecord.idOtherEnregistrementPreparation
      )
    }

    const formatedRecord = record.products
      ? {
          ...record,
          datePrise: moment(record.date).format('dddd DD MMMM YYYY [à] HH[h]mm'),
          employeePrise: record.prenom,
          recordName: record.products.length === 0 ? getProductName(record) : getRecetteName(record),
          formatedProducts: [
            ...formatedProducts().map(product => ({
              ...product,
              noImage: product.synced === false || product.synced === 'false',
              img:
                product.synced === true || product.synced === 'true'
                  ? HygieneService.getImagePath(context, product)
                  : noImage,
              fullSentence:
                product.fullSentence || [product.quantite, product.nomCond, product.text].filter(Boolean).join(' ')
            }))
          ],
          hasFormatedProducts: formatedProducts().length > 0,
          formatedCuissons: formatedCuissons(),
          hasFormatedCuissons: formatedCuissons().length > 0,
          formatedOtherPreparation: formatedOtherPreparation(),
          hasFormatedOtherPreparation: formatedOtherPreparation().length > 0,
          noProducts:
            formatedProducts().length === 0 &&
            formatedCuissons().length === 0 &&
            formatedOtherPreparation().length === 0,
          lot: record.lots,
          poids: `${record.poidsFinal} ${record.nom}`,
          dlc: record.products.length > 0 ? moment(record.dlc).format('dddd DD MMMM YYYY') : '',
          actions: record.commentaires,
          ls: record.ls,
          soudure: record.soudure
        }
      : {}

    return {
      date: moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
      record: {...formatedRecord}
    }
  },
  formatPreparationsToExportBoucherie(record, context, records, _1, _2, keyboard, conditionnementsVente) {
    const formatedRecord = record.ingredients
      ? {
          ...record,
          datePrise: moment(record.date).format('dddd DD MMMM YYYY [à] HH[h]mm'),
          employeePrise: `${record.prenomEmployee} ${record.nomEmployee}`,
          recordName: record.nomRecette,
          formatedProducts: record.ingredients.map(ingredient => ({
            ...ingredient,
            img: HygieneService.getImagePath(context, ingredient),
            fullSentence: `${ingredient.quantite} ${
              ingredient.nomConditionnementVente
            } ${ingredient.nom || ingredient.nomIngredientAditionnel}`
          })),
          hasFormatedProducts: true,
          formatedCuissons: [],
          hasFormatedCuissons: false,
          formatedOtherPreparation: [],
          hasFormatedOtherPreparation: false,
          noProducts: false,
          lot: record.numLot,
          poids: `${record.poidsFinal} ${record.nom}`,
          dlc: record.dlc,
          actions: record.commentaires,
          ls: CommonUtils.toBoolean(record.ls),
          soudure: record.soudure
        }
      : {}

    return {
      date: moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
      record: {...formatedRecord}
    }
  },
  formatPreparationsToExport: (context, records, _1, _2, keyboard, conditionnementsVente) => {
    const recordType = records.preparations ? records.preparations : records
    return recordType.map(record => {
      if (context === contexts.BOUCHERIE_CONTEXT) {
        return HygieneService.formatPreparationsToExportBoucherie(
          record,
          context,
          records,
          _1,
          _2,
          keyboard,
          conditionnementsVente
        )
      } else {
        return HygieneService.formatPreparationsToExportPoisson(
          record,
          context,
          records,
          _1,
          _2,
          keyboard,
          conditionnementsVente
        )
      }
    })
  },

  getPreparationsByUuid: uuid =>
    fetchWithToken(`${config().hygieneService}/preparations/${uuid}`, {method: 'GET'}).then(response =>
      response.json()
    ),
  formatPreparations: records => {
    return (records || []).map(record => {
      const produit = (() => {
        if (record.products && record.products.length > 0 && !record.nomRecette) {
          return `${record.products[0].text}`
        }
        return 'Produit traditionnel'
      })()

      return {
        title: `Préparation de ${moment(record.date, 'YYYY-MM-DD HH:mm').format('HH[h]mm')}`,
        subtitle: `N° de lot : ${record.lots} - ${record.nomRecette ? record.nomRecette : produit}`,
        color: 'red',
        date: moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
        logo: 'preparation.png',
        record,
        component: 'recordPreparations'
      }
    })
  },
  getParasitismesByDate: date =>
    fetchWithToken(`${config().hygieneService}/parasitismes?date=${date}`, {method: 'GET'}).then(response =>
      response.json()
    ),
  getParasitismesByRange: (currentContext, dateStart, dateEnd) =>
    fetchWithToken(`${config(currentContext).hygieneService}/parasitismes?dateStart=${dateStart}&dateEnd=${dateEnd}`, {
      method: 'GET'
    }).then(response => response.json()),
  formatParasitismesToExport: (context, records) =>
    records.map(record => ({
      date: moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
      record: {
        ...record,
        formatedDate: `${moment(record.date).format('DD/MM/YYYY HH:mm:ss')}`,
        photos: record.files
          ? record.files.map(photo => HygieneService.getImagePath(context, {...photo, synced: true}))
          : [],
        isConforme: record.niveauInfestation === 'Conforme',
        isMassive: record.niveauInfestation === 'Massive',
        isLimitee: record.niveauInfestation === 'Limitée',
        haveLots: record.lots && record.lots.length > 0
      }
    })),
  formatParasitismes: records =>
    (records || []).map(record => ({
      title: `Parasitisme de ${moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('HH[h]mm')}`,
      subtitle: ` Produit : ${record.nomProduit}`,
      color: '#20b2aa',
      date: moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
      logo: 'parasit.png',
      record,
      component: 'recordParasitisme'
    })),

  getExpeditionsByDate: date =>
    fetchWithToken(`${config().hygieneService}/expeditions?date=${date}`, {method: 'GET'}).then(response =>
      response.json()
    ),
  getExpeditionsByRange: (currentContext, dateStart, dateEnd) =>
    fetchWithToken(`${config(currentContext).hygieneService}/expeditions?dateStart=${dateStart}&dateEnd=${dateEnd}`, {
      method: 'GET'
    }).then(response => response.json()),
  formatExpeditionsToExport: (context, records) =>
    records.map(record => ({
      date: moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
      record: {
        ...record,
        formatedDate: `${moment(record.date).format('DD/MM/YYYY HH:mm:ss')}`,
        glacage: CommonUtils.toBoolean(record.glacage),
        parasites: CommonUtils.toBoolean(record.parasites)
      }
    })),
  formatExpeditions: records =>
    (records || []).map(record => ({
      title: `Expédition de ${moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('HH[h]mm')}`,
      subtitle: ` Produit : ${record.nomProduit}`,
      color: '#ffdab9',
      date: moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
      logo: 'shipment.png',
      record,
      component: 'recordExpedition'
    })),

  getGlacagesByDate: date =>
    fetchWithToken(`${config().hygieneService}/glacages?date=${date}`, {method: 'GET'}).then(response =>
      response.json()
    ),
  getGlacagesByRange: (currentContext, dateStart, dateEnd) =>
    fetchWithToken(`${config(currentContext).hygieneService}/glacages?dateStart=${dateStart}&dateEnd=${dateEnd}`, {
      method: 'GET'
    }).then(response => response.json()),
  formatGlacagesToExport: (context, records) =>
    records.map(record => ({
      date: moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
      record: {
        ...record,
        formatedDate: `${moment(record.date).format('DD/MM/YYYY HH:mm:ss')}`,
        photos: record.files
          ? record.files.map(photo => HygieneService.getImagePath(context, {...photo, synced: true}))
          : [],
        weightResultText: (() => {
          const weightResult = CalculUtils.round((record.poidsGlace / record.poidsProduit) * 100, 2)
          if (record.weightResult !== '' && record.weightResult !== 'err') {
            return weightResult >= 30
              ? `Glaçage conforme (${weightResult} %)`
              : `Glaçage non conforme (${weightResult} %), veuillez ajouter de la glace`
          }
          return ''
        })()
      }
    })),
  formatGlacages: records =>
    (records || []).map(record => ({
      title: `Glacage de ${moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('HH[h]mm')}`,
      subtitle: ` Produit : ${record.nomProduit}`,
      color: '#afeeee',
      date: moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
      logo: 'icing.png',
      record,
      component: 'recordGlacage'
    })),
  formatGroupedParasitismes: records => {
    const grouped = groupBy(records || [], 'date')
    return Object.keys(grouped).map(groupedDate => {
      const date = new Date(groupedDate)
      return {
        title: `Parasitisme ${dateUtils.toShortTime(date)}`,
        subtitle: `Effectué par ${grouped[groupedDate][0].prenom} ${grouped[groupedDate][0].nom}`,
        color: '#20b2aa',
        logo: 'parasit.png',
        done: true,
        date: moment(date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
        link: `/parasitisme/${moment(date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')}`,
        record: grouped[groupedDate],
        component: 'recordParasitisme'
      }
    })
  },
  formatGroupedAudits: records => {
    const grouped = groupBy(records || [], 'date')
    return Object.keys(grouped).map(groupedDate => {
      const date = new Date(groupedDate)
      return {
        title: `Vérification ${dateUtils.toShortTime(date)}`,
        subtitle: `${grouped[groupedDate].length} ${SentenceUtils.pluralize(grouped[groupedDate].length, ['item'])} ${SentenceUtils.pluralize(grouped[groupedDate].length, ['validé'])}`,
        color: '#e2c09e',
        logo: 'audit.png',
        done: true,
        date: moment(date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
        link: `/audit/${moment(date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')}`,
        record: grouped[groupedDate],
        component: 'recordAudit'
      }
    })
  },
  formatGroupedNettoyagesBoucherie: records => {
    const recordsGrouped = groupBy(records || [], 'date')
    return Object.keys(recordsGrouped).map(record => ({
      title: `Nettoyage de ${moment(recordsGrouped[record][0].date, 'YYYY-MM-DD HH:mm:ss').format('HH[h]mm')}`,
      subtitle: `Effectué par ${recordsGrouped[record][0].prenom} ${recordsGrouped[record][0].nom}`,
      color: '#f48fb1',
      date: moment(recordsGrouped[record][0].date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
      logo: 'cleaner.png',
      record: recordsGrouped[record][0],
      component: 'recordNettoyageBoucherie'
    }))
  },
  formatGroupedNettoyages: records => {
    const recordsGrouped = groupBy(records || [], 'date')
    return Object.keys(recordsGrouped).map(record => ({
      title: `Nettoyage de ${moment(recordsGrouped[record][0].date, 'YYYY-MM-DD HH:mm:ss').format('HH[h]mm')}`,
      subtitle: `Effectué par ${recordsGrouped[record][0].prenom} ${recordsGrouped[record][0].nom}`,
      color: '#f48fb1',
      date: moment(recordsGrouped[record][0].date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
      logo: 'cleaner.png',
      record: recordsGrouped[record][0],
      component: 'recordNettoyage'
    }))
  },
  getCongelationsByDate: date =>
    fetchWithToken(`${config().hygieneService}/congelations?date=${date}`, {method: 'GET'}).then(response =>
      response.json()
    ),
  getCongelationsByRange: (currentContext, dateStart, dateEnd) =>
    fetchWithToken(`${config().hygieneService}/congelations?dateStart=${dateStart}&dateEnd=${dateEnd}`, {
      method: 'GET'
    }).then(response => response.json()),
  getFraicheursByDate: date =>
    fetchWithToken(`${config().hygieneService}/fraicheur?date=${date}`, {method: 'GET'}).then(response =>
      response.json()
    ),
  formatCongelationsToExport: (context, records) =>
    records.map(record => ({
      date: moment(record.dateCongelation, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
      record: {
        ...record,
        formatedDate: `${moment(record.dateCongelation).format('DD/MM/YYYY')}`,
        img: HygieneService.getImagePath(context, {...record, synced: true}),
        formatedDateDecongelation: moment(record.dateDecongelation, 'YYYY-MM-DD').format('DD/MM/YYYY'),
        formatedHeureDecongelation: moment(record.heureDecongelation, 'HH:mm').format('HH[h]mm'),
        formatedDateCongelation: moment(record.dateCongelation, 'YYYY-MM-DD').format('DD/MM/YYYY'),
        formatedHeureCongelation: moment(record.heureCongelation, 'HH:mm').format('HH[h]mm')
      }
    })),
  formatFraicheurs: records =>
    (records || []).map(record => {
      return {
        title: `Test fraicheur ${moment(record.date, 'YYYY-MM-DD HH:mm:ss').format(' [à] HH[h]mm')}`,
        subtitle: record.nomProduit,
        color: '#FFD700',
        logo: 'fraicheur.png',
        date: moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
        component: 'recordFraicheur',
        record
      }
    }),
  formatCongelations: records =>
    (records || []).map(record => ({
      title: `${record.isFreezed === true ? 'Décongélation' : 'Congélation'} de ${moment(record.heureCongelation, 'HH:mm').format('HH[h]mm')}`,
      subtitle: `Fournisseur : ${record.nomFournisseur} - ${record.text}`,
      color: '#ADD8E6',
      date: moment(record.dateCongelation).format('YYYY-MM-DD'),
      logo: 'congelation.png',
      record,
      component: 'recordCongelation'
    })),

  getCalibragesByDate: (currentContext, date) => {
    return fetchWithToken(`${config(currentContext).hygieneService}/calibrages?date=${date}`, {method: 'GET'}).then(
      response => response.json()
    )
  },
  getCalibragesByRange: (currentContext, dateStart, dateEnd) =>
    fetchWithToken(`${config(currentContext).hygieneService}/calibrages?dateStart=${dateStart}&dateEnd=${dateEnd}`, {
      method: 'GET'
    }).then(response => response.json()),
  formatCalibragesToExport: (context, records) =>
    records.map(record => ({
      date: moment(record.dateCalibrage, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
      record: {
        formatedDate: moment(record.dateCalibrage, 'YYYY-MM-DD HH:mm').format('[le] DD/MM/YYYY'),
        ...record,
        hasNomElement: !!record.nomElement,
        hasPoidsTare: !!record.poidsTare
      }
    })),
  formatCalibrages: (records, keyboard) =>
    (records || []).map(record => {
      const subTitleType = (() => {
        const hasProduct = !!record.idCode && !!record.idDenomination
        const productName = KeyboardService.retreiveSentence(
          {
            idCode: parseInt(record.idCode, 10),
            idDenomination: parseInt(record.idDenomination, 10)
          },
          keyboard,
          null
        )
        if (hasProduct) {
          return `Produit : ${productName}`
        }
        if (record.poidsTare !== 0 && record.sondeValeur !== 0) {
          return `Sonde : ${record.sondeValeur} °C | ${record.tare === 'false' ? `${record.poidsTare !== 0 ? 'Tare non conforme' : ''}` : 'Tare conforme'}`
        }
        if (record.sondeValeur !== 0) {
          return `Sonde : ${record.sondeValeur} °C`
        }
        if (record.poidsTare !== 0) {
          return `${record.tare === 'false' ? `${record.poidsTare !== 0 ? 'Tare non conforme' : ''}` : ' Tare Conforme'}`
        }
        if (record.etancheiteConforme === false && record.poidsTare !== 0) {
          return 'Étanchéité non conforme'
        }
        if (record.poidsTare === 0) {
          return 'Tare 0 gr'
        }
        return ' '
      })()
      const emojiTitle = () => {
        if (!!record.idCode && !!record.idDenomination) {
          return '🐟'
        }
        if (record.sondeValeur !== 0 && record.poidsTare === 0) {
          return '🌡'
        }
        if (record.poidsTare !== 0 && record.sondeValeur === 0) {
          return '⚖️'
        }
        if (record.poidsTare !== 0 && record.sondeValeur !== 0) {
          return '🌡 ⚖️'
        }
        return '⚠️'
      }
      return {
        title: `Calibrage de ${moment(record.dateCalibrage, 'YYYY-MM-DD HH:mm:ss').format('HH[h]mm')} ${emojiTitle()}`,
        subtitle: `${subTitleType} - Effectué par ${record.prenomEmploye} ${record.nomEmploye}`,
        color: '#00DFA2',
        date: `${moment(record.dateCalibrage, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')}`,
        logo: 'calibrage.png',
        record,
        component: 'recordCalibrage'
      }
    }),

  getFumaisonsByDate: date =>
    fetchWithToken(`${config().hygieneService}/fumaisons?date=${date}`, {method: 'GET'}).then(response =>
      response.json()
    ),
  getFumaisonsByRange: (currentContext, dateStart, dateEnd) =>
    fetchWithToken(`${config(currentContext).hygieneService}/fumaisons?dateStart=${dateStart}&dateEnd=${dateEnd}`, {
      method: 'GET'
    }).then(response => response.json()),
  formatFumaisonsToExport: (context, records) =>
    records.map(record => ({
      date: moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
      record: {
        ...record,
        formatedDate: moment(record.date, 'YYYY-MM-DD HH:mm').format('[le] DD/MM/YYYY'),
        dlc: moment(record.date, 'YYYY-MM-DD HH:mm').add(record.dlc, 'days').format('[le] DD/MM/YYYY'),
        isGravlax: CommonUtils.toBoolean(record.gravlax),
        hasDessalage: !CommonUtils.toBoolean(record.gravlax) && record.idEmployeesDessalage !== null && record.idEmployeesDessalage !== '',
        hasRincage: CommonUtils.toBoolean(record.gravlax) && record.idEmployeesDessalage !== null && record.idEmployeesDessalage !== '',
        hasSechage: record.idEmployeesSechage !== null && record.idEmployeesSechage !== '',
        hasFumage: record.idEmployeesFumage !== null && record.idEmployeesFumage !== '',
        hasRefroidissement: record.idEmployeesRefroidissement !== null && record.idEmployeesRefroidissement !== '',
        hasMaturation: record.idEmployeesMaturation !== null && record.idEmployeesMaturation !== '',
        dateFinFumage: HygieneService.formatDate(record.dateFinFumage),
        heureDebutRefroidissement: HygieneService.formatHour(record.heureDebutRefroidissement),
        heureFinRefroidissement: HygieneService.formatHour(record.heureFinRefroidissement),
        dateDebutMaturation: HygieneService.formatDate(record.dateDebutMaturation),
        heureDebutMaturation: HygieneService.formatHour(record.heureDebutMaturation),
        dateFinMaturation: HygieneService.formatDate(record.dateFinMaturation),
        heureFinMaturation: HygieneService.formatHour(record.heureFinMaturation),
        dateDebutSalage: HygieneService.formatDate(record.dateDebutSalage),
        heureDebutSalage: HygieneService.formatHour(record.heureDebutSalage),
        dateFinSalage: HygieneService.formatDate(record.dateFinSalage),
        heureFinSalage: HygieneService.formatHour(record.heureFinSalage),
        dateDebutDessalage: HygieneService.formatDate(record.dateDebutDessalage),
        heureDebutDessalage: HygieneService.formatHour(record.heureDebutDessalage),
        dateFinDessalage: HygieneService.formatDate(record.dateFinDessalage),
        heureFinDessalage: HygieneService.formatHour(record.heureFinDessalage),
        dateDebutSechage: HygieneService.formatDate(record.dateDebutSechage),
        heureDebutSechage: HygieneService.formatHour(record.heureDebutSechage),
        dateFinSechage: HygieneService.formatDate(record.dateFinSechage),
        heureFinSechage: HygieneService.formatHour(record.heureFinSechage),
        dateDebutFumage: HygieneService.formatDate(record.dateDebutFumage),
        heureDebutFumage: HygieneService.formatHour(record.heureDebutFumage),
        products: (() => {
          // IF FILE > 2, show only the most recent products
          const grouped = groupBy(record.products, 'file')
          const sorted = Object.values(grouped).map(product =>
            product.sort((a, b) => moment(a.date, 'YYYY-MM-DD HH:mm:ss') < moment(b.date, 'YYYY-MM-DD HH:mm:ss'))
          )
          return sorted
            .map(obj => obj[0])
            .map(product => {
              return {
                ...product,
                img: product ? HygieneService.getImagePath(context, product) : '',
                nomProduct: `${product.quantite} ${record.conditionnements.filter(cond => cond.idConditionnementVente === product.idConditionnementVente)[0].nom}`
              }
            })
        })(),
        recetteCategory: (() => {
          if (record.salted === 'true') {
            return '(Salée)'
          }
          if (record.saumure === 'true') {
            return '(Saumurée)'
          }
          if (record.readyFum === 'true') {
            return '(Prêt à fumer)'
          }
          if (CommonUtils.toBoolean(record.gravlax)) {
            return '(Gravlax)'
          }

          return ''
        })(),
        formatedDateFumaison: (() => {
          return moment(record.date, 'YYYY-MM-DD HH:mm').format('DD/MM/YYYY')
        })(),
        formatedHeureFumaison: (() => {
          return moment(record.date, 'YYYY-MM-DD HH:mm').format('HH[h]mm')
        })()
      }
    })),
  formatFumaisons: records =>
    (records || []).map(record => ({
      title: `Fumaison de ${moment(record.date, 'YYYY-MM-DD HH:mm').format('HH[h]mm')} - ${record.recetteName}`,
      subtitle: `${record.completed === 'true' || record.completed === true ? 'Terminée' : 'Commencée'} par ${record.prenom} ${record.nom}`,
      color: '#9e9e9e',
      date: `${moment(record.date, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD')}`,
      logo: 'fumaison.png',
      record,
      component: 'recordFumaison'
    })),
  formatReceptions: records =>
    (records || []).map(record => ({
      title: `Réception de ${moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('HH[h]mm')}`,
      subtitle: `Effectué par ${record.prenom} ${record.nom} - ${record.nomProduit}`,
      color: '#3f3f3f',
      date: moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
      logo: 'reception.png',
      record,
      component: 'recordReception'
    })),
  formatReceptionsBoucherie: records => {
    return (records || []).map(record => {
      return {
        title: `Réception de ${moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('HH[h]mm')}`,
        subtitle: `Effectué par ${record.prenomEmployee} ${record.nomEmployee}`,
        color: '#3f3f3f',
        date: moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
        logo: 'reception.png',
        record,
        component: 'recordReception'
      }
    })
  },
  formatNettoyages: records =>
    (records || []).map(record => ({
      title: `Nettoyage de ${moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('HH[h]mm')}`,
      subtitle: `Effectué par ${record.prenom} ${record.nom}`,
      color: '#f48fb1',
      date: moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
      logo: 'cleaner.png',
      record,
      component: 'recordNettoyage'
    })),
  formatNettoyagesBoucherie: records =>
    (records || []).map(record => ({
      title: `Nettoyage de ${moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('HH[h]mm')}`,
      subtitle: `Effectué par ${record.prenom} ${record.nom}`,
      color: '#f48fb1',
      date: moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
      logo: 'cleaner.png',
      record,
      component: 'recordNettoyageBoucherie'
    })),
  formatAudits: records =>
    (records || []).map(record => ({
      title: `Vérifications du ${moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('HH[h]mm')}`,
      subtitle: `Effectué par ${record.prenom} ${record.nom}`,
      color: '#e2c09e',
      date: moment(record.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
      logo: 'audit.png',
      record,
      component: 'recordAudit'
    }))
}
